import '../webpack-path';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Main } from '@bbkAdminComponents/main';

createRoot(document.querySelector('#ReactApp')!).render(<Main />);
